import { get } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { z } from "zod";

const checkExistsResponseSchema = z.object({
  exists: z.boolean(),
});

type CheckExistsResponse = z.infer<typeof checkExistsResponseSchema>;

export async function checkIfEmailExists(email: string): Promise<CheckExistsResponse> {
  const response = await get({
    url: `${environmentConfig.REACT_APP_BASE_API_URL}/user/checkIfEmailExists`,
    responseSchema: checkExistsResponseSchema,
    queryParams: { email },
  });
  return response.data;
}

export async function checkIfPhoneExists(phone: string): Promise<CheckExistsResponse> {
  const response = await get({
    url: `${environmentConfig.REACT_APP_BASE_API_URL}/user/checkIfPhoneExists`,
    responseSchema: checkExistsResponseSchema,
    queryParams: { phone },
  });
  return response.data;
}
